import React from "react";
import { Dropdown } from "react-bootstrap";
import cx from "classnames";
import _ from "lodash";

import styles from "./styles.module.scss";

import { localizedStrings } from "src/localization/index.jsx";
import Truncate from "src/components/truncate";
import Tooltip from "src/components/tooltip";

class OpportunityFieldDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: props.fields,
      selected: props.selected,
      selectedPipeline: null,
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.disableDropdown = this.disableDropdown.bind(this);
    this.handleSelectPipeline = this.handleSelectPipeline.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons
  }

  handleSelect(item) {
    if(this.props.addNewCustomField){
      this.props.addNewCustomField(item);
    }
  }

  onRemoveField(item) {
    this.props.onRemove(item);
  }

  disableDropdown() {
    return this.state.selected ? true : false;
  }

  handleSelectPipeline(item) {
    const updatedField = {
      ...this.state.selected,
      values : item.stages
    }
    if(this.props.updateField){
      this.props.updateField(updatedField);
    }
    this.setState({ selectedPipeline: item, selected: updatedField });
  }


  render() {
    return (
      <div className={styles.fieldDropdown}>
        <div className={styles.field}>
          <Dropdown
            key={this.state.selected ? this.state.selected.name : ""}
          >
            <Tooltip content={this.state.selected
              ? this.state.selected.label
              : this.localizedIntegrations.select_field}>
              <span >
                <Dropdown.Toggle disabled={this.disableDropdown()} className={styles.dropdown}>

                  <Truncate className={cx(styles.text, this.disableDropdown() && styles.disabled)} width={170} >
                    {this.state.selected
                      ? this.state.selected.label
                      : this.localizedIntegrations.select_field}
                  </Truncate>
                </Dropdown.Toggle>
              </span>
            </Tooltip>

            <Dropdown.Menu className={styles.dropdownMenu}>
              <div className={styles.options}>
                {this.state.fields &&
                  this.state.fields.map((item) => {
                    return (
                      <Dropdown.Item
                        key={item.name}
                        eventKey={item}
                        onClick={() => this.handleSelect(item)}
                        className={styles.item}
                      >
                        {item.label}
                      </Dropdown.Item>
                    );
                  })}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>

       { this.props.hubspotPipelines && _.get(this.state,"selected.id") === "dealstage" && <div className={styles.field}>
          <Dropdown
            key={this.state.selected ? this.state.selected.name : ""}
          >
            <Tooltip content={this.state.selectedPipeline
              ? this.state.selectedPipeline.name
              : this.localizedIntegrations.select_field}>
              <span >
                <Dropdown.Toggle  className={styles.dropdown}>

                  <Truncate className={cx(styles.text)} width={170} >
                    {this.state.selectedPipeline
                      ? this.state.selectedPipeline.name
                      : "Select Pipeline"}
                  </Truncate>
                </Dropdown.Toggle>
              </span>
            </Tooltip>

            <Dropdown.Menu className={styles.dropdownMenu}>
              <div className={styles.options}>
                {this.props.hubspotPipelines &&
                  this.props.hubspotPipelines.map((item) => {
                    return (
                      <Dropdown.Item
                        key={item.name}
                        eventKey={item}
                        onClick={() => this.handleSelectPipeline(item)}
                        className={styles.item}
                      >
                        {item.name}
                      </Dropdown.Item>
                    );
                  })}
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>}

      {_.get(this.state,"selected.values",[]).length > 0 &&  <div className={styles.listValues}>
          {this.state.selected && (
            <Dropdown rootCloseEvent="click">
              <Dropdown.Toggle className={styles.dropdown}>
                <span className={cx(styles.text,styles.uppercase)}> { this.localizedIntegrations.view_list_values } </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.dropdownMenu}>
                <div className={styles.options}>
                  {this.state.selected.values &&
                    this.state.selected.values.map((item, index) => {
                      return (
                        <Dropdown.Item key={item.label} className={styles.item}>
                          {item.label}
                        </Dropdown.Item>
                      );
                    })}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>}

        <div
          className={styles.remove}
          onClick={() => this.onRemoveField(this.state.selected)}
        >
          <span className={styles.text}> { this.localizedCommons.actions.remove } </span>
        </div>
      </div>
    );
  }
}

export default OpportunityFieldDropdown;
